/** Stable partition: ids in `pending` first, everyone else after, each group keeping its incoming order. Never mutates `rows`. */
export function pendingFirst<T>(rows: readonly T[], idOf: (row: T) => string, pending: ReadonlySet<string>): T[] {
  if (pending.size === 0) return [...rows]
  const first: T[] = []
  const rest: T[] = []
  for (const row of rows) (pending.has(idOf(row)) ? first : rest).push(row)
  return [...first, ...rest]
}
